import api, {onQueryStarted} from "../../store/api"
import {FlashService} from "../../flash/flash-service";
import {Container} from "aurelia-dependency-injection"

const flash = Container.instance.get(FlashService)

const bankingApi = api.injectEndpoints({
    endpoints: build => ({
        assign: build.mutation({
            query: ({workflowId, id, body}) => ({
                url: `${workflowId}/trigger/${id}`,
                method: "PATCH",
                body
            }),
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    flash.error(
                        error?.error?.data?.message || 'Assignment failed'
                    );
                }
            },
            invalidatesTags: (result, error, {id}) => [{type: "banking-api/transaction", id}],
        }),
    })
})

export const {
    useAssignMutation
} = bankingApi
